module.exports = __webpack_public_path__ + "img/shortcode_banner.86b32bbe.png";